import { CarMakerDemoRows, CarMakerDemoColumns } from "../Data_Sets/Demo Data Sets/CarMakerDemoDataSet.js";
import { RailOperatorDemoRows, RailOperatorDemoColumns } from "../Data_Sets/Demo Data Sets/RailOperatorDemoDataSet.js";
import { AirlineDemoRows, AirlineDemoColumns } from "../Data_Sets/Demo Data Sets/AirlineDemoDataSet.js";
import { RetailDemoRows, RetailDemoColumns } from "../Data_Sets/Demo Data Sets/RetailDemoDataSet.js";
import { FinanceDemoRows, FinanceDemoColumns } from "../Data_Sets/Demo Data Sets/FinanceDemoDataSet.js";
import { TryItRows, TryItColumns } from "../Data_Sets/TryItTableData.js";

export const CreateSubscribedTopicString = (activeTab, activeDataChip) => {
    const selectedItems = [];
    const STORAGE_KEY = 'TryItData';
    let datasetColumns;
    let datasetRows;

        if (activeTab === "demo") {
            if (activeDataChip === "car_maker") {
                datasetColumns = CarMakerDemoColumns;
                datasetRows = CarMakerDemoRows;
            } else if (activeDataChip === "rail_operator") {
                datasetColumns = RailOperatorDemoColumns;
                datasetRows = RailOperatorDemoRows;
            }else if (activeDataChip === "airline") {
                datasetColumns = AirlineDemoColumns;
                datasetRows = AirlineDemoRows;
            }else if (activeDataChip === "retail") {
                datasetColumns = RetailDemoColumns;
                datasetRows = RetailDemoRows;
            }else if (activeDataChip === "finance") {
                datasetColumns = FinanceDemoColumns;
                datasetRows = FinanceDemoRows;
            }
        } else {
            // User Input Table
            const savedData = localStorage.getItem(STORAGE_KEY);
            const parsedData = savedData ? JSON.parse(savedData) : { columns: TryItColumns, rows: TryItRows };
            datasetColumns = parsedData.columns;
            datasetRows = parsedData.rows;
        }

        // Remove everything after the > wildcard
        for (const column of datasetColumns) {
            const columnKey = column.field;
            const availableItems = datasetRows
                .map(row => row[columnKey])
                .filter(item => item !== undefined && item !== "");

            if (availableItems.length > 0) {
                const randomIndex = Math.floor(Math.random() * availableItems.length);
                const selectedItem = availableItems[randomIndex];

                if (selectedItem === ">") {
                    selectedItems.push(selectedItem);
                    break;
                }

                selectedItems.push(selectedItem);
            }
        }
        
        return selectedItems.join(' / ');
};

export default CreateSubscribedTopicString;